import { makeStyles } from '@material-ui/core';
import themes from '../../styles/themes';
import { DESKTOP_AMIRA_MESSAGE_WIDTH } from '../../constants';

export const useStyles = makeStyles((theme) => ({
    messageContainer: {
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 1004 * 0.8,
        whiteSpace: 'pre-wrap',
    },
    sideBar: {
        position: 'fixed',
        // '@media (min-width: 1024px)': {
        //     position: 'absolute',
        // },
        width: 'auto',
        left: 0,
        zIndex: 1000000,
        top: 0,
        bottom: 0,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    overlay: {
        background: '#000',
        width: '100%',
        position: 'absolute',
        left: 0,
        zIndex: 99,
        top: 0,
        opacity: '0.5',
    },
    sideBarIconContainer: {
        width: '50px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    messageContainerUser: {
        alignSelf: 'flex-end',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        borderBottomLeftRadius: '12px',
        background: '#1A1A1A',
        marginBottom: '8px',
    },
    messageContainerAssistant: {
        alignSelf: 'flex-start',
        borderTopRightRadius: '12px',
        borderBottomRightRadius: '12px',
        borderBottomLeftRadius: '12px',
        background: '#FBF4EE',
        width: '80%',
        '@media (min-width: 1024px)': {
            width: `80%`,
        },
    },
    personalMessageContainerAssistant: {
        padding: '4px 12px',
        display: 'flex',
        textAlign: 'center',
        flexDirection: 'column',
        whiteSpace: 'pre-wrap',
        alignSelf: 'flex-start',
        borderRadius: '44px',
        background: '#F2F2F2',
        width: '100%',
        '@media (min-width: 1024px)': {
            width: `80%`,
        },
    },
    messageImageContainer: {
        maxWidth: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        borderRadius: '12px',
    },
    messageContentImage: {
        borderTopRightRadius: '12px',
        borderBottomRightRadius: '12px',
        borderBottomLeftRadius: '12px',
        background: '#FBF4EE',
        marginBottom: '5px',
        padding: '2px',
        width: '80%',
        maxWidth: 1004 * 0.8,
        textAlign: 'center',
        overflow: 'hidden',
        '@media (min-width: 1024px)': {
            width: `${DESKTOP_AMIRA_MESSAGE_WIDTH}px`,
        },
    },
    styleActionContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        marginBottom: '4px',
    },
    styleAction: {
        borderRadius: '8px',
        background: '#FBF4EE',
        flex: 1,
        padding: '7px 0px',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    actionIcon: {
        height: '20px',
        width: '20px',
    },
    defaultMessageSize: {
        fontSize: '14px',
    },
    personalizeMessageSize: {
        fontSize: '12px',
    },
    messageContent: {
        fontWeight: 400,
        fontFamily: 'Poppins',
    },
    messageTextUser: {
        color: '#ffffff',
    },
    messageTextAssistant: {
        color: '#1A1A1A',
    },
    messageTime: {
        fontSize: '8px',
        fontWeight: 400,
        fontFamily: 'Poppins',
        marginTop: '8px',
        alignSelf: 'flex-end',
    },
    buttonContainer: {
        width: '80%',
        border: '1px solid #A3A3A3',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 10px',
        marginTop: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'Poppins',
        '@media (min-width: 1024px)': {
            width: `80%`,
        },
    },
    buttonContent: {
        fontSize: '12px',
        fontWeight: 400,
        fontFamily: 'Poppins',
        color: '#1A1A1A',
    },
    optionsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        flexDirection: 'row',
        width: '80%',
        marginBottom: '10px',
        '@media (min-width: 1024px)': {
            width: `80%`,
        },
    },
    optionLabel: {
        padding: '8px',
        background: '#FBF4EE',
        borderRadius: '47px',
        flex: 1,
        whiteSpace: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontWeight: 600,
        cursor: 'pointer',
        border: '1px #A3A3A3 solid',
        textTransform: 'uppercase',
    },
    elementTemplateMessage: {
        width: '100%',
        border: '1px solid #A3A3A3',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 10px',
        marginBottom: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'Poppins',
        background: '#ffffff',
    },
    multiOptionLabel: {
        padding: '8px',
        background: '#FBF4EE',
        borderRadius: '8px',
        flex: 1,
        whiteSpace: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontWeight: 600,
        cursor: 'pointer',
        textTransform: 'uppercase',
    },
    shopNowLabel: {
        background: themes.palette.primary.main,
        color: '#FFFFFF',
        border: '2px solid #1A1A1A',
        borderRadius: 42,
        padding: 7,
        flex: 1,
        whiteSpace: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontWeight: 600,
        cursor: 'pointer',
        textTransform: 'uppercase',
    },
    showMoreButton: {
        width: '100%',
        marginBottom: '8px',
    },
    textField: {
        width: '100%',
        fontFamily: 'Poppins',
        background: '#F2F2F2',
        borderRadius: '38px',
        minHeight: '38px',
        padding: '8px 16px',
    },
    headerSpacing: {
        padding: '14px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    signupButton: {
        background: '#1A1A1A',
        borderRadius: '29px',
        padding: '7px 50px',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '14px',
        color: '#FFFFFF',
        width: '100%',
        justifyContent: 'center',
        display: 'flex',
    },
    loginButton: {
        background: '#FFFFFF',
        border: '1px solid #1A1A1A',
        borderRadius: '29px',
        padding: '7px 50px',
        width: '100%',
        justifyContent: 'center',
        display: 'flex',
    },
    menuButton: {
        padding: '8px 4px',
    },
    menuButtonText: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '14px',
        color: '#1A1A1A',
    },
    menuDivider: {
        border: '1px solid #F2F2F2',
        width: '100%',
        margin: '8px 4px',
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
    },
    headerTitle: {
        marginLeft: '12px',
        marginRight: '4px',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: 400,
    },
    onlineIndicator: {
        height: '6px',
        width: '6px',
        borderRadius: '6px',
        background: '#34D058',
    },
    footerContainer: {
        padding: '12px',
        background: '#ffffff',
    },
    linkIcon: {
        marginLeft: '12px',
        marginBottom: '5px',
    },
    styleImage: {
        width: 'auto',
        borderRadius: '12px',
        cursor: 'pointer',
        background: '#ffffff',
        objectFit: 'contain',
        maxWidth: '100%',
    },
    messageWrapper: {
        padding: '10px',
        overflow: 'auto',
        background: '#ffffff',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    messageLoadingContainer: {
        padding: '10px',
        display: 'flex',
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
        borderBottomLeftRadius: '8px',
        background: '#FBF4EE',
        width: 'fit-content',
    },
    messageLoadCon: {
        display: 'flex',
        background: '#FBF4EE',
        width: 'fit-content',
    },
    loaderIcon: {
        marginLeft: 4,
        width: 4,
        height: 4,
    },
    spinnerLoader: {
        width: 18,
        height: 18,
    },
    elementSpace: {
        width: '4px',
    },
    blackDot: {
        '& > path': {
            fill: '#000000',
        },
    },
    customTextField: {
        '& .MuiInputBase-root': {
            fontFamily: 'PoppinsRegular',
            fontSize: 14,
        },
        '& textarea:focus': {
            fontSize: 14,
        },
        '& .MuiInput-underline': {
            '&.Mui-focused': {
                bottom: 0,
                borderBottom: '0px',
            },
            '&:hover': {
                borderBottom: '0px',
            },
            '&:before': {
                borderBottom: '0px',
            },
            '&:after': {
                borderBottom: '0px',
            },
        },
        '& [class*="MuiInput-underline"]:hover:before': {
            borderBottom: 0,
        },
    },
    readMoreText: {
        color: '#000000',
        textDecoration: 'underline',
        cursor: 'pointer',
    },

    // Style quiz complete popup

    styleQuizPopupContainer: {
        position: 'absolute',
        left: '50%',
        top: '12%',
        transform: 'translate(-50%, -50%)',
        background: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        borderRadius: 999,
        width: 200,
        height: 36,
        padding: 8,
        zIndex: 50,
    },
    styleQuizPopupTextContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    styleQuizPopupText: {
        color: 'white',
        margin: 0,
        fontFamily: 'Poppins',
        fontSize: 12,
        cursor: 'pointer',
    },
    styleQuizPopupHr: {
        height: 20,
        width: 2,
        margin: 0,
        background: '#484848',
    },
    styleQuizPopupClose: {
        cursor: 'pointer',
    },
    styleQuizIconContainer: {
        borderRadius: 999,
        border: '2px solid #D1D1D1',
        padding: '0px 4px',
        cursor: 'pointer',
    },
    styleQuizIconImage: {
        objectFit: 'cover',
        marginBottom: '4px',
    },
    itemImageSliderDrawer: {
        borderTopRightRadius: 24,
        borderTopLeftRadius: 24,
        padding: 10,
        height: '80vh',
    },
    itemImagePopupCloseBtn: {
        cursor: 'pointer',
        width: 20,
    },
    itemImageSlideWrapper: {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    imageImageSlide: {
        height: 'calc(100% - 60px)',
        width: 'auto',
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'contain',
    },
    itemDetailHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 10,
        marginBottom: 10,
        borderBottom: '1px solid #d1d1d1',
    },
    itemDetailTitle: {
        margin: 0,
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontSize: 14,
        color: themes.palette.primary.main,
        whiteSpace: 'nowrap',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    itemDetailPriceAndClose: {
        display: 'flex',
        alignItems: 'center',
    },
    itemDetailPrice: {
        padding: 10,
        background: themes.palette.primary.light,
        borderRadius: 10,
        fontFamily: 'PoppinsRegular',
        fontWeight: 600,
        fontSize: 14,
        color: themes.palette.primary.main,
        marginRight: 6,
    },
    shopButton: {
        width: '100%',
        height: '48px',
        padding: '15px 0',
        color: 'white',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        border: 'none',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:disabled': {
            opacity: 0.5,
        },
    },
    newConversationButtonContainer: {
        background: '#fff',
        padding: '10px',
    },
    newConversationButton: {
        padding: '12px',
        border: '1px solid #D1D1D1',
        borderRadius: '42px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        fontSize: '13px',
        fontFamily: 'PoppinsRegular',
        fontWeight: 600,
    },
}));
